import _get from 'lodash/get';

export const getShouldIncludeFieldInProfile = ({
  account = false,
  signUp = false,
  clientDetails,
  backdoor = false,
}) => {
  const userProfileFields =
    account && _get(clientDetails, 'metadata.userProfileFields');
  const signUpUserProfileFields =
    signUp && _get(clientDetails, 'metadata.signUpUserProfileFields');

  const shouldIncludeFieldInProfile = fieldName => {
    if (backdoor) {
      if (fieldName === 'firstName' || fieldName === 'lastName') return true;
      if (signUpUserProfileFields) {
        return signUpUserProfileFields.includes(fieldName);
      }
      if (userProfileFields) {
        return userProfileFields.includes(fieldName);
      }
      return true;
    }

    return signUpUserProfileFields
      ? signUpUserProfileFields.includes(fieldName)
      : userProfileFields
      ? userProfileFields.includes(fieldName)
      : true;
  };

  return shouldIncludeFieldInProfile;
};

export const isSignUpPeriod = auth =>
  auth?.createdAt ? Date.now() - auth.createdAt < 5 * 60 * 1000 : false;
